const { jsPDF } = require('jspdf');
const { autoTable } = require('jspdf-autotable');
const { drawMunicipalPdfHeader } = require('./municipalPdfHeader');

/** Documento impresso com início de página exclusivo para cada unidade. */
function buildStockDispatchPdf(receipts, options = {}) {
    if (!receipts.length) throw new Error('Nenhum comprovante para imprimir.');
    const doc = new jsPDF({ unit: 'mm', format: 'a4', compress: true });
    const margin = 18;
    const width = 174;
    const emittedAt = new Date(options.generatedAt || Date.now());
    const emissionDate = emittedAt.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' });
    const header = receipt => {
        let y = drawMunicipalPdfHeader(doc, receipt.secretaryName, margin);
        doc.setTextColor(27, 45, 66); doc.setFont('helvetica', 'bold'); doc.setFontSize(16);
        doc.text('Saída de materiais', margin, y); y += 7;
        doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
        doc.text(`Comprovante ${receipt.receiptNumber}`, margin, y); y += 8;
        for (const [label, value] of [['Unidade', receipt.unitName], ['Local destinatário', receipt.localName || 'Entrega à unidade (registro anterior)']]) {
            doc.setFont('helvetica', 'bold'); doc.setFontSize(9); doc.text(label, margin, y);
            doc.setFont('helvetica', 'normal');
            const lines = doc.splitTextToSize(value || 'Não informado', width - 40);
            doc.text(lines, margin + 40, y); y += Math.max(7, lines.length * 4.5 + 2);
        }
        return y + 3;
    };
    receipts.forEach((receipt, index) => {
        if (index) doc.addPage();
        const startY = header(receipt);
        autoTable(doc, {
            startY, margin: { left: margin, right: margin, top: startY, bottom: 18 },
            head: [['Material', 'Quantidade']],
            body: receipt.lines.map(line => [line.description, String(line.quantity)]),
            theme: 'grid',
            styles: { font: 'helvetica', fontSize: 10, cellPadding: 3, overflow: 'linebreak', lineColor: [210, 215, 220], lineWidth: 0.15 },
            headStyles: { fillColor: [35, 57, 79], textColor: 255, fontStyle: 'bold' },
            columnStyles: { 0: { cellWidth: 143 }, 1: { cellWidth: 31, halign: 'center' } },
            rowPageBreak: 'avoid',
            didDrawPage: () => { header(receipt); },
        });
        let y = doc.lastAutoTable.finalY + 8;
        const ensure = height => {
            if (y + height > 275) { doc.addPage(); y = header(receipt); }
        };
        if (receipt.notes) {
            const notes = doc.splitTextToSize(`Observações: ${receipt.notes}`, width);
            doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
            notes.forEach(line => { ensure(5); doc.text(line, margin, y); y += 4.5; });
            y += 5;
        }
        ensure(56);
        doc.setTextColor(27, 45, 66); doc.setFont('helvetica', 'normal'); doc.setFontSize(10);
        doc.text(`Data de emissão: ${emissionDate}`, margin, y); y += 9;
        const statement = doc.splitTextToSize('Declaro que recebi os materiais relacionados neste comprovante, nas quantidades indicadas.', width);
        doc.text(statement, margin, y); y += statement.length * 5 + 10;
        if (receipt.recipientName) {
            const receiver = doc.splitTextToSize(`Recebedor: ${receipt.recipientName}`, width);
            ensure(receiver.length * 5 + 30);
            doc.text(receiver, margin, y); y += receiver.length * 5 + 6;
        }
        doc.setDrawColor(90, 102, 115);
        doc.line(margin, y + 5, 127, y + 5);
        doc.line(139, y + 5, 192, y + 5);
        doc.setFontSize(9);
        doc.text('Assinatura do recebedor', margin, y + 10);
        doc.text('Data do recebimento', 139, y + 10);
        doc.setFontSize(8);
    });
    const pages = doc.getNumberOfPages();
    for (let page = 1; page <= pages; page++) {
        doc.setPage(page); doc.setFont('helvetica', 'normal'); doc.setFontSize(8); doc.setTextColor(100, 110, 120);
        doc.text('Comprovante de entrega de materiais', margin, 287);
        doc.text(`Página ${page} de ${pages}`, 192, 287, { align: 'right' });
    }
    return doc;
}
function downloadStockDispatchPdf(receipts) {
    buildStockDispatchPdf(receipts).save(`saida-materiais-${receipts[0].receiptNumber.replace(/[^a-z0-9-]/gi, '-')}.pdf`);
}
module.exports = { buildStockDispatchPdf, downloadStockDispatchPdf };
